import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useCurrentUser } from "hooks/useCurrentUser";

function AuthGuard({ children, ...rest }) {
  const { userToken } = useCurrentUser();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        userToken ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default AuthGuard;
